<template lang="pug">
div.pad
  el-row(:gutter="30")
    el-col(:span="12")
      validation-provider(rules="required|cpf", v-slot="{ errors }", name="CPF")
        app-label(label="CPF:")
        el-input.input(
          name='CPF',
          v-model="pessoa.pessoaFisica.cpf",
          v-mask="'###.###.###-##'",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="12")
      validation-provider(rules="required", v-slot="{ errors }", name="Nome")
        app-label(label="Nome:")
        el-input.input(
          name='Nome',
          v-model="pessoa.pessoaFisica.nome",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

  el-row(:gutter="30")
    el-col(:span="8")
      validation-provider(:rules="requiredRg.rules", v-slot="{ errors }", name="RG")
        app-label(label="RG:", :required="requiredRg.label")
        el-input.input(
          name='RG',
          v-model="pessoa.pessoaFisica.rg",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="8")
      validation-provider(:rules="requiredRg.rules", v-slot="{ errors }", name="Órgão expedidor")
        app-label(label="Órgão expedidor:", :required="requiredRg.label")
        el-select.input(
          name='Órgão Expedidor'
          class="select",
          no-match-text="Nenhum Orgão Encontrado",
          placeholder="Selecione",
          v-model="pessoa.pessoaFisica.orgaoExpedidor.nome"
          value-key="id"
          filterable,
          clearable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="orgaoExpedidor in orgaosExpedidores",
            :key="orgaoExpedidor.id",
            :label="orgaoExpedidor.nome",
            :value="orgaoExpedidor.nome"
          )
        span.help.erro {{ errors[0] }}
    el-col(:span="8")
      validation-provider(:rules="requiredRg.rules", v-slot="{ errors }", name="UF do RG")
        app-label(label="UF do RG:", :required="requiredRg.label")
        el-select.input(
          name='UF do RG'
          class="select",
          no-match-text="Nenhuma UF Encontrada",
          placeholder="Selecione",
          v-model="pessoa.pessoaFisica.orgaoExpedidor.estado"
          clearable,
          filterable,
          :disabled="!pessoa.pessoaFisica.orgaoExpedidor.nome",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="estado in estadosBr",
            :key="estado.codigo",
            :label="estado.nome",
            :value="estado.codigo"
          )
        span.help.erro {{ errors[0] }}

  el-row(:gutter="30")
    el-col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", name="Nacionalidade")
        app-label(label="Nacionalidade:")
        el-select.input(
          name='Nacionalidade'
          class="select",
          no-match-text="Nenhuma Nacionalidade Encontrada",
          placeholder="Selecione",
          v-model="pessoa.pessoaFisica.nacionalidade"
          value-key="id"
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in gentilico",
            :key="item.id",
            :label="item.gentilico +' - '+ item.nomePais",
            :value="item.sigla",
          )
        span.help.erro {{ errors[0] }}
    el-col(:span="16")
      validation-provider(rules="required|email", v-slot="{ errors }", name="E-mail")
        app-label(label="E-mail:", rules="required")
        el-input.input(
          name="E-mail",
          v-model="pessoa.pessoaFisica.email",
          label='email',
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row
    el-col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }", name="Estado civil")
          app-label(label="Estado civil:")
          el-select.input(
            class="select",
            name='Estado civil'
            v-model="pessoa.pessoaFisica.estadoCivil",
            value-key="codigo"
            no-match-text="Nenhum estado civil encontrado",
            placeholder="Selecione",
            clearable,
            filterable,
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="item in estadosCivil",
              :key="item.codigo",
              :label="item.nome",
              :value="item.codigo"
            )
          span.help.erro {{ errors[0] }}

</template>
<script>
import { mapActions } from 'vuex'

import AppLabel from '@/components/AppLabel'
import estadosBr from '@/constants/estados'
import gentilico from '@/constants/gentilico'
const {estadosCivil} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppLabel
  },

  props: {
    pessoa: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      fone: '',
      oldEstadoCod: '',
      orgaosExpedidores: [],
      estadosBr,
      gentilico,
      estadosCivil,
      municipios: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      isMaranhao: process.env.ESTADO === 'ma'
    }
  },

  mounted () {
    this.setOrgaosExpeditores()
  },
  computed: {
    requiredRg () {
      if (this.isMaranhao) {
        return { rules: '', label: false }
      }
      return { rules: 'required', label: true }
    }
  },
  methods: {
    ...mapActions({
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()
    }
  }

}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.conjuge {
  margin-left: 15px;
}
.select {
  width: 100%;
}

.full-width {
  width: 100%;
}

.marginTop {
  margin-top: 5px;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppPessoaSocio.vue